import { useRef } from 'react';
import toast from 'react-hot-toast';

export const useErrorToast = () => {
  const errorMessagesRef = useRef(new Set());
  const timeoutRef = useRef(null);

  const handleApiError = (errorMessage) => {
    errorMessagesRef.current.add(errorMessage);

    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      const messages = Array.from(errorMessagesRef.current);
      const combinedMessage =
        messages.length > 1
          ? `Multiple errors occurred:\n- ${messages.join('\n- ')}`
          : messages[0];

      toast.error(combinedMessage, {
        id: 'batched-error', // ensures only one toast shows at a time
        duration: 5000,
      });

      errorMessagesRef.current.clear();
      timeoutRef.current = null;
    }, 500); // Adjust debounce time if needed
  };

  return handleApiError;
};
